exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loader-container[data-v-0700e555] {\n  width: 100%;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/block/block-apartments-grid/styles.scss"],"names":[],"mappings":";AAAA;EACE,YAAW;CACZ","file":"styles.scss","sourcesContent":[".loader-container{\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0700e555","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/block/block-apartments-grid/styles.scss
// module id = WuW+
// module chunks = 0